import styles from './styles.module.css';

import { useRef, useMemo } from 'react';
import Popup from 'ui/Popup';
import { address_server_short, PUBLIC_ASSETS } from 'config';
import { observer } from 'mobx-react-lite';
import { SchemeObjectTypes } from 'consts/scheme.consts';

export const SampleTypeWrapper = observer(({ children, object }) => {
  const popupRef = useRef(null);

  const portalContent = useMemo(() => {
    if (!object) return <div>Не удалось получить информацию о типе</div>;

    return (
      <div className={styles.container}>
        <div className={styles.cardInfo}>
          <div
            style={{
              display: 'flex',
            }}
          >
            <div className={styles.image}>
              <img
                src={address_server_short + PUBLIC_ASSETS + object.image}
                alt="N/A"
                className={styles.picture}
              />
            </div>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '0.5rem',
                justifyContent: 'center',
              }}
            >
              <div className={styles.value}>{object.name}</div>
            </div>
          </div>
          <div className={styles.description}>
            <div className={styles.label}>Описание</div>
            <div className={styles.value}>{object.description}</div>
          </div>
        </div>

        {object?.type === SchemeObjectTypes.typeSamples && (
          <div className={styles.cardInfo}>
            <div className={styles.line}>
              <div className={styles.label}>Количество циклов разморозки</div>
              <div className={styles.value}>{object.defreeze ?? 'Не указано'}</div>
            </div>

            <div className={styles.line}>
              <div className={styles.label}>Единица измерения</div>
              <div className={styles.value}>{object.unit?.name}</div>
            </div>
          </div>
        )}
        <div className={styles.cardInfo}>
          <div className={styles.line}>
            <div className={styles.label}>Пользовательские параметры</div>
            <div className={styles.value}>
              {object?.user_fields?.length
                ? object?.user_fields?.map((field) => field.name).join(', ')
                : 'Не указано'}
            </div>
          </div>
        </div>
      </div>
    );
  }, [object]);

  if (object?.value) return children;

  return (
    <Popup ref={popupRef}>
      {children}

      <Popup.Portal>{portalContent}</Popup.Portal>
    </Popup>
  );
});

export default SampleTypeWrapper;
